/**
 * Legend 영역에서 마우스 우 클릭시의 Context Menu 관련 기능 구현
 */

// import { ToastProgrammatic as Toast } from 'buefy'

// import Plotly from 'plotly.js-dist'
import BriqueChart from './BriqueChart.vue'
import EventHandler from './EventHandler.js'

export default {
  /**
   * Legend 마우스 우측 버튼 클릭 기능 초기화(이벤트 등록)
   * @param {Object} element 차트 Element Object
   */
  initLegendContextMenu (element) {
    element.on('plotly_legendclick', function (data) {
      if (data.event.button !== 2) { // 마우스 오른쪽 버튼 클릭이 아니면
        return true
      }

      let e = data.event
      e.stopPropagation()
      e.preventDefault()

      let clientX = e.clientX
      let clientY = e.clientY

      element.parentElement.__vue__.legendContextMenu.visible = true
      element.briqueChartData.selectedSeriesNameForContextMenu = data.data[data.curveNumber].name

      setTimeout(() => {
        let menu = document.querySelector(`#chart_legend_contextmenu_${element.id}`)

        let x = (clientX + menu.clientWidth) > document.body.clientWidth ? (clientX - menu.clientWidth) : clientX
        let y = (clientY + menu.clientHeight) > document.body.clientHeight ? (clientY - menu.clientHeight) : clientY

        menu.style.left = `${x}px`
        menu.style.top = `${y}px`
      })

      return false
    })

    EventHandler.removeAndAddEventListener(element, `contextmenu.${element.id}_chart_legend_contextmenu`, (e) => {
      if (EventHandler.matches.call(e.target, 'rect.legendtoggle')) { // legend 영역의 우 클릭 방지
        e.stopPropagation()
        e.preventDefault()
        return false
      }

      // if (!EventHandler.matches.call(e.target, 'rect.nsewdrag.drag')) return
      console.log(element.parentElement)
      console.log(element.parentElement.__vue__)
      // visible한 메뉴가 하나도 없으면 메뉴 자체가 안보이게
      if (!element.parentElement.__vue__.legendContextMenu.list.some((item) => typeof (item.visible) === 'function' ? item.visible() : item.visible)) {
        return
      }

      return false
    })

    EventHandler.removeAndAddEventListener(document.body, `click.${element.id}_chart_legend_contextmenu`, (e) => {
      // chart split 해제 후 없어진 element이면
      if (_.isEmpty(document.getElementById(element.id))) {
        EventHandler.removeEventListener(document.body, `click.${element.id}_chart_legend_contextmenu`)
        return
      }

      if (element.parentElement.__vue__.legendContextMenu.visible !== true) {
        return
      }

      element.parentElement.__vue__.legendContextMenu.visible = false
      BriqueChart.react(element, element.data, undefined, undefined, undefined, false)
    })
  },

  /**
   * Legend에서 우 클릭시 표시할 Context Menu 리스트를 구한다.
   * @param {Object}} chartVue Chart Vue 객체
   * @returns Legend의 Context Menu 리스트
   */
  getLegendContextMenu: (chartVue) => {
    return {
      visible: false,
      selectedSeriesName: '',
      list: [
        {
          label: chartVue.$t('fdc.CHART_COMPONENT.LABEL.Y_AXIS_PRIMARY'),
          visible: () => {
            let element = chartVue.$el.children[0]
            return element.data.length >= 2
          },
          disabled: () => {
            let element = chartVue.$el.children[0]
            let seriesName = element.briqueChartData.selectedSeriesNameForContextMenu
            let index = element.briqueChartData.seriesStyles.map(trace => trace.name).indexOf(seriesName)
            return element.briqueChartData.seriesStyles[index]?.yaxis !== 'y2'
          },
          click: () => {
            let element = chartVue.$el.children[0]
            let seriesName = element.briqueChartData.selectedSeriesNameForContextMenu
            let index = element.briqueChartData.seriesStyles.map(trace => trace.name).indexOf(seriesName)

            chartVue.$refs.chartModal.data.seriesYAxisNameList[index] = 'y'
            BriqueChart.applySeriesYAxis(chartVue, chartVue.$refs.chartModal.data, chartVue.$refs.chartModal.oldData)
          }
        },
        {
          label: chartVue.$t('fdc.CHART_COMPONENT.LABEL.Y_AXIS_SECONDARY'),
          visible: () => {
            let element = chartVue.$el.children[0]
            return element.data.length >= 2
          },
          disabled: () => {
            let element = chartVue.$el.children[0]
            let seriesName = element.briqueChartData.selectedSeriesNameForContextMenu
            let index = element.briqueChartData.seriesStyles.map(trace => trace.name).indexOf(seriesName)
            return element.briqueChartData.seriesStyles[index]?.yaxis === 'y2'
          },
          click: () => {
            let element = chartVue.$el.children[0]
            let seriesName = element.briqueChartData.selectedSeriesNameForContextMenu
            let index = element.briqueChartData.seriesStyles.map(trace => trace.name).indexOf(seriesName)

            chartVue.$refs.chartModal.data.seriesYAxisNameList[index] = 'y2'
            BriqueChart.applySeriesYAxis(chartVue, chartVue.$refs.chartModal.data, chartVue.$refs.chartModal.oldData)
          }
        },
        {
          label: chartVue.$t('fdc.CHART_COMPONENT.LABEL.CONNECTOR_SHOW'),
          visible: () => {
            let element = chartVue.$el.children[0]
            let seriesName = element.briqueChartData.selectedSeriesNameForContextMenu
            let seriesStyle = element.briqueChartData.getSeriesStyle(seriesName)
            if (seriesStyle && seriesStyle.mode) {
              return !seriesStyle.mode.includes('none') && !seriesStyle.mode.includes('lines')
            } else {
              return false
            }
          },
          disabled: () => {
            let element = chartVue.$el.children[0]
            let seriesName = element.briqueChartData.selectedSeriesNameForContextMenu
            let seriesStyle = element.briqueChartData.getSeriesStyle(seriesName)

            if (seriesStyle && seriesStyle.mode) {
              return seriesStyle.mode.includes('lines')
            } else {
              return false
            }
          },
          click: () => {
            let element = chartVue.$el.children[0]
            let seriesName = element.briqueChartData.selectedSeriesNameForContextMenu
            let seriesStyle = element.briqueChartData.getSeriesStyle(seriesName)
            element.briqueChartData.setSeriesStyle(seriesName, { mode: `${seriesStyle.mode}+lines` })

            BriqueChart.react(element, element.data)
          }
        },
        {
          label: chartVue.$t('fdc.CHART_COMPONENT.LABEL.CONNECTOR_HIDE'),
          visible: () => {
            let element = chartVue.$el.children[0]
            let seriesName = element.briqueChartData.selectedSeriesNameForContextMenu
            let seriesStyle = element.briqueChartData.getSeriesStyle(seriesName)

            if (seriesStyle && seriesStyle.mode) {
              return (seriesStyle.mode.includes('markers') && seriesStyle.mode.includes('lines'))
            } else {
              return false
            }
          },
          disabled: () => {
            let element = chartVue.$el.children[0]
            let seriesName = element.briqueChartData.selectedSeriesNameForContextMenu
            let seriesStyle = element.briqueChartData.getSeriesStyle(seriesName)
            if (seriesStyle && seriesStyle.mode) {
              return !(seriesStyle.mode.includes('markers') && seriesStyle.mode.includes('lines'))
            } else {
              return false
            }
          },
          click: () => {
            let element = chartVue.$el.children[0]
            let seriesName = element.briqueChartData.selectedSeriesNameForContextMenu
            let seriesStyle = element.briqueChartData.getSeriesStyle(seriesName)
            element.briqueChartData.setSeriesStyle(seriesName, { mode: seriesStyle.mode.replace(/\+?lines$/, '').replace(/^lines\+?/, '') })

            BriqueChart.react(element, element.data)
          }
        },
        // { label: 'Marker 표시', // 나중에 다국어 처리 필요
        //   visible: () => {
        //     let element = chartVue.$el.children[0]
        //     let seriesName = element.briqueChartData.selectedSeriesNameForContextMenu
        //     let seriesStyle = element.briqueChartData.getSeriesStyle(seriesName)

        //     return !seriesStyle.mode.includes('markers')
        //   },
        //   disabled: () => {
        //     let element = chartVue.$el.children[0]
        //     let seriesName = element.briqueChartData.selectedSeriesNameForContextMenu
        //     let seriesStyle = element.briqueChartData.getSeriesStyle(seriesName)

        //     return seriesStyle.mode.includes('markers')
        //   },
        //   click: () => {
        //     let element = chartVue.$el.children[0]
        //     let seriesName = element.briqueChartData.selectedSeriesNameForContextMenu
        //     let seriesStyle = element.briqueChartData.getSeriesStyle(seriesName)
        //     element.briqueChartData.setSeriesStyle(seriesName, { mode: `${seriesStyle.mode}+markers` })

        //     BriqueChart.react(element, element.data)
        //   }
        // },
        // { label: 'Marker 표시 해제', // 나중에 다국어 처리 필요
        //   visible: () => {
        //     let element = chartVue.$el.children[0]
        //     let seriesName = element.briqueChartData.selectedSeriesNameForContextMenu
        //     let seriesStyle = element.briqueChartData.getSeriesStyle(seriesName)

        //     return seriesStyle.mode.includes('markers') && seriesStyle.mode.includes('lines')
        //   },
        //   disabled: () => {
        //     let element = chartVue.$el.children[0]
        //     let seriesName = element.briqueChartData.selectedSeriesNameForContextMenu
        //     let seriesStyle = element.briqueChartData.getSeriesStyle(seriesName)

        //     return !(seriesStyle.mode.includes('markers') && seriesStyle.mode.includes('lines'))
        //   },
        //   click: () => {
        //     let element = chartVue.$el.children[0]
        //     let seriesName = element.briqueChartData.selectedSeriesNameForContextMenu
        //     let seriesStyle = element.briqueChartData.getSeriesStyle(seriesName)
        //     element.briqueChartData.setSeriesStyle(seriesName, { mode: seriesStyle.mode.replace(/\+?markers$/, '').replace(/^markers\+?/, '') })

        //     BriqueChart.react(element, element.data)
        //   }
        // },
        {
          label: chartVue.$t('fdc.CHART_COMPONENT.LABEL.MARKER_SELECT'),
          visible: () => {
            let element = chartVue.$el.children[0]
            let seriesName = element.briqueChartData.selectedSeriesNameForContextMenu
            let seriesStyle = element.briqueChartData.getSeriesStyle(seriesName)
            if (seriesStyle && seriesStyle.mode && seriesStyle.mode.includes('markers')) {
              return true
            } else {
              return false
            }
          },
          disabled: () => {
            return false
          },
          click: () => {
            let element = chartVue.$el.children[0]

            let seriesName = element.briqueChartData.selectedSeriesNameForContextMenu
            BriqueChart.openChartModalMarker(element, seriesName)
          }
        },
        {
          label: chartVue.$t('fdc.CHART_COMPONENT.LABEL.COLOR_SELECT'),
          visible: () => {
            let element = chartVue.$el.children[0]
            let seriesName = element.briqueChartData.selectedSeriesNameForContextMenu
            let seriesStyle = element.briqueChartData.getSeriesStyle(seriesName)
            // TODO: 아래 visible false 시킨 chart type은 추후 처리 필요함
            if (seriesStyle && seriesStyle.type && (seriesStyle.type === 'histogram2d' || seriesStyle.type === 'histogram2dcontour')) {
              return false
            } else {
              return true
            }
          },
          disabled: () => {
            return false
          },
          click: () => {
            let element = chartVue.$el.children[0]

            let seriesName = element.briqueChartData.selectedSeriesNameForContextMenu
            BriqueChart.openChartModalColor(element, seriesName)
          }
        },
        {
          label: chartVue.$t('fdc.CHART_COMPONENT.LABEL.CHART_TYPE_CHANGE'),
          visible: () => {
            return true
          },
          disabled: () => {
            return false
          },
          click: () => {
            let element = chartVue.$el.children[0]

            let seriesName = element.briqueChartData.selectedSeriesNameForContextMenu
            BriqueChart.openChartModalChartType(element, seriesName)
          }
        }
      ]
    }
  }
}
